import { Col, Container, Row } from "react-bootstrap";
import vamosjuntos from "../../assets/img/logo.png";
import web from "../../assets/img/web.png";
import yt from "../../assets/img/yt.png";
import fb from "../../assets/img/fb.png";
import ig from "../../assets/img/ig.png";
import WhatsAppFlotante from "../WhatsAppFlotante/WhatsAppFlotante";

const Footer = () => {
  const query = new URLSearchParams(window.location.search);
  if (query) {
    if (query.get("utm_source")) {
      sessionStorage.setItem("utm_source", query.get("utm_source"));
    }
    if (query.get("utm_medium")) {
      sessionStorage.setItem("utm_medium", query.get("utm_medium"));
    }
  }
  const utm_source = query && query.get("utm_source");
  const utm_medium = query && query.get("utm_medium");

  let utms = "";
  if (utm_source !== null && utm_medium !== null) {
    utms = `?utm_source=${utm_source}&utm_medium=${utm_medium}`;
  }

  return (
    <>
      <Container fluid className="footer pb-4" name="footer">
        <Row>
          <Col>
            <Container>
              <Row>
                <Col md={12} xs={12} className="mx-auto">
                  <Row className="d-flex justify-content-start flex-md-row flex-column align-content-start align-items-start">
                    <Col style={{ maxWidth: "320px" }}>
                      <div className="text-md-start text-center">
                        <img src={vamosjuntos} className="img-fluid" alt="Montironi" />
                      </div>
                    </Col>

                    <Col className="ps-md-5 ps-0 text-md-start text-center pt-md-0 pt-4">
                      <p className="txt-seguinos" style={{ fontSize: "14px" }}>
                        Los cupos son limitados. El registro al evento no confirma la participación.{" "}
                        <br className="d-md-block d-none" /> Un asesor comercial se comunicará por mail o WhatsApp para
                        confirmar tu participación.
                      </p>
                    </Col>

                    <Col
                      className="d-flex justify-content-md-end justify-content-center  flex-md-row flex-column"
                      style={{ maxWidth: "400px" }}
                    >
                      <div className="d-flex justify-content-md-between justify-content-center align-items-center align-content-center flex-md-row flex-column pt-md-0 pt-3">
                        <p className="pt-3 pe-md-0 txt-seguinos">Seguinos en nuestras redes:</p>
                      </div>

                      <div className="d-flex justify-content-md-start justify-content-center align-items-center align-content-center ">
                        <div className="p-md-2">
                          <a href="https://www.facebook.com/MontironiFord" target="_blank" rel="noreferrer">
                            <img src={fb} />
                          </a>
                        </div>
                        <div className="p-md-2">
                          <a href="https://www.instagram.com/montironi.ford/?hl=es" target="_blank" rel="noreferrer">
                            <img src={ig} />
                          </a>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
      <Container fluid className="footerWhite">
        <Row>
          <Col>
            <h4>
              Copyright © 2024 Montironi Automotores. <br className="d-block d-md-none" /> Todos los derechos reservados
            </h4>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Footer;
